<style lang="scss" scoped>
.link-preview-link {
  display: flex;
  text-decoration: none;
  color: #444;
  background: white;
  padding: 10px;
  margin: 0 0 10px;
  border-radius: 5px;
  border: 1px solid #ccc;

  &:hover {
    .link-preview-title {
      text-decoration: underline;
    }
    .link-preview-thumbnail {
      opacity: 0.8;
    }
  }
}
.link-preview-text-link {
  margin: 0 0 10px;
  a {
    font-size: 1.4rem;
    color: #444;
    display: inline-block;
    margin: 0 0 5px;
  }
  .description {
    font-size: 1.2rem;
    line-height: 1.7rem;
  }
}
.link-preview-thumbnail {
  width: 100px;
}
.link-preview-content {
  flex: 1;
  margin-left: 10px;
}
.link-preview-title {
  font-size: 1.6rem;
  line-height: 2.3rem;
  margin: 0 0 5px;
}
.link-preview-description {
  font-size: 1.2rem;
  line-height: 1.8rem;
}
</style>
<template>
  <div class="link-preview">
    <div class="link-preview-text-link" v-if="linkOnly">
      <a href="url" target="_blank">{{ title }}</a>
      <p class="description">{{ shorten(description) }}</p>
    </div>
    <a class="link-preview-link" href="url" target="_blank" v-else>
      <div class="link-preview-thumbnail" v-if="image_url && image_url.length">
        <img :src="image_url" class="img-responsive" />
      </div>
      <div class="link-preview-content">
        <div class="link-preview-title">{{ title }}</div>
        <p class="link-preview-description">{{ shorten(description) }}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    linkOnly() {
      return this.image_url && this.image_url.length === 0;
    },
  },
  props: {
    title: String,
    image_url: String,
    description: String,
    url: String,
  },
  methods: {
    shorten(str) {
      const threshold = 100;
      if (str.length < threshold) return str;

      return `${str.substring(0, threshold)}...`;
    },
  },
};
</script>
